/* Scoped custom element: no global timers or storefront data writes. */
(() => {
  if (customElements.get('fl-editorial-slideshow')) return;
  class EditorialSlideshow extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.slides = [...this.querySelectorAll('[data-fl-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.labels = [this.dataset.firstLabel, 'Black Friday'];
      this.pauseButton = this.querySelector('[data-fl-pause]');
      this.status = this.querySelector('[data-fl-status]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.inView = false;
      this.interval = Math.max(5000, Number(this.dataset.interval) || 7000);
      this.querySelector('[data-fl-controls]').hidden = false;
      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateControls();
        this.schedule();
      }, options);
      this.addEventListener('focusin', event => {
        // Focus on the pause control itself must not flip its state before a click.
        if (!event.target.closest('[data-fl-pause]')) this.stop();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.stop(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, {threshold: 0.15});
      this.observer.observe(this);
      this.updateControls();
      this.show(0);
    }
    stop() {
      this.paused = true;
      this.updateControls();
      clearTimeout(this.timer);
    }
    manual(i) { this.stop(); this.show(i); }
    show(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, n) => {
        slide.inert = n !== this.index;
        slide.setAttribute('aria-hidden', String(n !== this.index));
      });
      const label = this.labels[this.index];
      this.status.textContent = label;
      this.dataset.activeSlide = String(this.index + 1);
    }
    updateControls() {
      this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      this.pauseButton.querySelector('[data-fl-pause-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
      this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      this.dataset.paused = String(this.paused);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || !this.inView || document.hidden) return;
      this.timer = setTimeout(() => {
        this.show(this.index + 1);
        this.schedule();
      }, this.interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('fl-editorial-slideshow', EditorialSlideshow);
})();
